import Routes from './routes'
import 'windi.css'
import '../../assets/css/index.scss'

export default {
  // name version 必须为字面常量
  name: 'portal-homepage-std',
  title: '门户首页',
  version: '0.2.70',
  description: '门户首页',
  routes: Routes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [],
  },
  config: {},
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
  init: () => {
    const portalPrimaryColor = localStorage.getItem('portalPrimaryColor')
    if (portalPrimaryColor) {
      const root = document.querySelector(':root')
      root.style.setProperty('--portalPrimaryColor', portalPrimaryColor)
      root.style.setProperty('--portalPrimaryBgColor', `${portalPrimaryColor}14`)
    }
  },
}
